module.exports = {
    count: "Mostrando de {from} a {to} de {count} registros|{count} registros|Un registro",
    first: 'Primero',
    last: 'Último',
    filter: "Filtro:",
    filterPlaceholder: "Busqueda",
    limit: "Registros:",
    page: "Página:",
    noResults: "No se encontro registro.",
    filterBy: "Filtrar por {column}",
    loading: 'Cargando...',
    defaultOption: 'Seleccionar {column}',
    columns: 'Columnas'
};